import { Grid, Tooltip } from "@material-ui/core";
import IconEye from "app/common/Icon/IconEye";
import {
  FEE_TAB,
  REGISTER_CARD_TAB,
  VOUCHER_INVOICE_TYPE,
  VOUCHER_STATUS_VALUE,
} from "app/common/LocalConst";
import {
  formatMoney,
  getDateTime,
  isRoleChiefTechician,
  isRoleHisReadOnly,
  isRoleTechician,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import VoucherPopupDetail from "../FeeTab/Popup/VoucherPopupDetail";
const ListVoucherPayment = ({ initialPatient, setCurrentTab }) => {
  const { t } = useTranslation();
  const {
    getDataDetailVoucher,
    openVoucherPopupDetail,
    handleCloseServiceFeePopup,
    dataVoucherPopupFee,
    editableVoucher,
    handleUpdateVoucher,
    listStk,
  } = useStore().feeStore.serviceFeeTabStore;
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const location = useLocation();
  const isInDetailPage =
    location.pathname === "/treatment-management/treatment-patient-info-detail";
  const isReadonly = isRoleHisReadOnly();
  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        height: "100%",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid
        container
        spacing={1}
        className="m-0 w-100"
        style={{ backgroundColor: "aliceblue" }}
      >
        <Grid item xs={12} className="search-title-card">
          <p className="title-block">Thanh toán</p>
          <div className="flex align-center flex-end gap-1 cursor">
            <p
              className="button-more"
              onClick={() => {
                if (isInDetailPage) {
                  setCurrentTab(REGISTER_CARD_TAB);
                } else {
                  setCurrentTab(FEE_TAB);
                }
              }}
            >
              Xem thêm
            </p>
          </div>
        </Grid>

        <Grid item xs={12}>
          {(initialPatient?.voucherList || []).map((item, index) => (
            <div
              style={{
                borderBottom: "1px solid gray",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div key={index} style={{ padding: "10px" }}>
                <div className="flex gap-2 items-center">
                  <span
                    style={{
                      fontSize: "var(--fs-base)",
                      fontWeight: 600,
                      color: "#3faef4",
                      borderBottom: "3px solid #3faef4",
                      paddingBottom: "2px",
                    }}
                  >
                    TG tạo: {getDateTime(item?.voucherDate)}
                  </span>
                  {item?.code && (
                    <>
                      <span> - </span>
                      <span
                        style={{
                          fontSize: "var(--fs-base)",
                          fontWeight: 600,
                          color: "#3faef4",
                          borderBottom: "3px solid #3faef4",
                          paddingBottom: "2px",
                        }}
                      >
                        {item.code}
                      </span>
                    </>
                  )}

                  {item?.status === VOUCHER_STATUS_VALUE.Cancel && (
                    <>
                      <span> - </span>
                      <span
                        style={{
                          fontSize: "var(--fs-base)",
                          fontWeight: 600,
                          color: "red",
                          borderBottom: "3px solid red",
                          paddingBottom: "2px",
                        }}
                      >
                        ĐÃ HỦY
                      </span>
                    </>
                  )}
                </div>
                <div style={{ marginTop: 2 }}>
                  {VOUCHER_INVOICE_TYPE.find(
                    (v) => v.value === item.voucherInvoiceType
                  ) && (
                    <span
                      style={{ fontSize: "var(--fs-base-two)", color: "#666" }}
                    >
                      Loại phiếu:
                      <b style={{ marginLeft: 4 }}>
                        {
                          VOUCHER_INVOICE_TYPE.find(
                            (v) => v.value === item.voucherInvoiceType
                          ).name
                        }
                      </b>
                    </span>
                  )}
                </div>
                <div>
                  {item?.items?.some((i) => i.staffRevenues?.length > 0) && (
                    <div>
                      <span
                        style={{
                          fontSize: "var(--fs-base-two)",
                          color: "#666",
                        }}
                      >
                        Nhân viên:
                        <b style={{ marginLeft: 4 }}>
                          {(() => {
                            const seen = new Set();
                            const allStaffs = item.items
                              .flatMap((i) => i.staffRevenues || [])
                              .filter((s) => {
                                const id = s.staff?.id;
                                if (!id || seen.has(id)) return false;
                                seen.add(id);
                                return true;
                              })
                              .map(
                                (s) =>
                                  `${s.staff?.staffName} (${s.staff?.code})`
                              );
                            return allStaffs.join(", ");
                          })()}
                        </b>
                      </span>
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "8px" }}>
                  <div
                    style={{
                      fontSize: "var(--fs-base-two)",
                      color: "#374151",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "var(--fs-base-two)",
                        color: "black",
                        fontWeight: "bold",
                        marginBottom: "4px",
                      }}
                    >
                      Ghi chú:
                    </span>{" "}
                    {item.note || "Không có ghi chú"}
                  </div>
                </div>
                <div
                  className="flex flex-wrap gap-2 mt-2"
                  style={{ alignItems: "center" }}
                >
                  <div
                    style={{
                      fontSize: "var(--fs-base-two)",
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                    }}
                  >
                    Cơ sở:
                    <b style={{ fontSize: "var(--fs-base-two)" }}>
                      {item.department?.name || "Không có cơ sở"}
                    </b>
                  </div>
                  <span>|</span>
                  <div
                    style={{
                      flex: "1 1 auto",
                      minWidth: 0,
                      fontSize: "var(--fs-base-two)",
                    }}
                  >
                    Tổng tiền:
                    <b
                      style={{ color: "green", fontSize: "var(--fs-base-two)" }}
                    >
                      <Tooltip title="Tổng tiền">
                        <span
                          style={{
                            fontWeight: "bold",
                            color: item.voucherType === -1 ? "red" : "green",
                          }}
                        >
                          {item.voucherType === -1
                            ? ` -${formatMoney(item?.moneyAfterDiscount)}`
                            : formatMoney(item?.moneyAfterDiscount)}
                        </span>
                      </Tooltip>
                    </b>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px",
                }}
              >
                {!isRoleCt ||
                  (!isReadonly && (
                    <Tooltip title="Xem chi tiết">
                      <div
                        className="flex"
                        onClick={() => getDataDetailVoucher(item)}
                      >
                        <IconEye />
                      </div>
                    </Tooltip>
                  ))}
              </div>
            </div>
          ))}
        </Grid>
      </Grid>
      {openVoucherPopupDetail && (
        <VoucherPopupDetail
          open={openVoucherPopupDetail}
          handleClose={handleCloseServiceFeePopup}
          detailData={dataVoucherPopupFee}
          editable={editableVoucher}
          handleUpdateVoucher={handleUpdateVoucher}
          listStk={listStk}
        />
      )}
    </div>
  );
};

export default memo(observer(ListVoucherPayment));
